/* Gets initial cookie value and provides function for seting cookie with new value
 * @param name
 * @returns {Array} Array for cookie value and function to update cookie value
 */
export default function useCookie(name) {
  const cookie = getAllCookies()[name] || null;

  /*
   * @param {string} value
   * @param {{path:string, domain: string, 'max-age': string, expires: string, secure: boolean, samesite: boolean}} options
   */
  const setCookie = (value, options) => {
    writeCookieToDocument(name, value, options);
  };

  return [cookie, setCookie];
}

export function destroyCookies() {
  Object.keys(getAllCookies()).forEach(name => {
    writeCookieToDocument(name);
  });
}

/*
 * @returns {Object}
 */
function getAllCookies() {
  if (typeof document === 'undefined') return {};
  const cookie = document.cookie;
  if (!cookie) return {};
  const cookieArray = cookie.split('; ');
  let cookieObject = {};
  cookieArray.forEach(cookieString => {
    const c = cookieString.split('=');
    cookieObject[c[0]] = c[1] || null;
  });

  return cookieObject;
}

/*
 * If no options are provided, then writeCookieToDocument will use the default
 * options to set the cookie to no value and expire at the end of session
 * @param {string} name
 * @param {string} value
 * @param {{path:string, domain: string, 'max-age': string, expires: string, secure: boolean, samesite: boolean}} options
 * @returns {string}
 */
export function writeCookieToDocument(name = '', value = '', options = {}) {
  const defaultOptions = {
    path: '/',
    domain: '.education.com',
    'max-age': '',
    expires: '',
    secure: '',
    samesite: '',
  };

  let optionsString = '';
  //max-age needs a number or to be excluded, otherwise Safari will not save the cookie
  if (!options['max-age']) {
    delete defaultOptions['max-age'];
  }

  Object.entries(defaultOptions).forEach(([key, value]) => {
    if (!options[key]) optionsString += `; ${key}=${value}`;
    else optionsString += `; ${key}=${options[key]}`;
  });

  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${value}${optionsString}`;
}
